module.exports = __webpack_public_path__ + "img/BlueAnalytics.f50513e8.jpg";